import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { Status } from 'lavva.exalushome/build/js/DataFrame';
import { ISequenceInfo } from 'lavva.exalushome/build/js/Services/Scenes/Scenes';
import { IconButton } from '@mui/material';
import { ActionAdvancedIcon } from '../../../../../../components/advanced-icon';
import { IconPlay } from '../../../../../../assets/icons/icon-play';
import { ROUTES } from '../../../../../../routes/routes';
import { ActionAdvancedIconTypeEnum } from '../../../../../../types';
import { useExalusServicesContext } from '../../../../context/services';
import { useHandleDataFrameErrors } from '../../../../hooks/errors';
import './index.scss';

type ActionItemProps = {
  action: ISequenceInfo;
};

const ActionItem: React.FC<ActionItemProps> = ({ action }) => {
  const navigate = useNavigate();
  const { scenesApi } = useExalusServicesContext();
  const { handleError } = useHandleDataFrameErrors();

  const runSequence = async () => {
    const result = await scenesApi.RunSequenceAsync(action.Guid);
    if (result !== Status.OK) handleError(result);
  };

  return (
    <div className={classNames('exalus-action-item', { disabled: action.IsDisabled })}>
      <div onClick={() => navigate(ROUTES.ExalusActionDetails(action.Guid))} className="exalus-action-item__content">
        <div className="icon">
          <ActionAdvancedIcon iconName={action.Icon || ActionAdvancedIconTypeEnum.DEFAULT} />
        </div>
        <div className="name">{action.Name}</div>
      </div>
      <IconButton className="action-btn" onClick={runSequence}>
        <IconPlay size={28} />
      </IconButton>
    </div>
  );
};

export default ActionItem;
